import { useCallback } from 'react'
import * as VanillaCookieConsent from 'vanilla-cookieconsent'
import 'vanilla-cookieconsent/dist/cookieconsent.css'

import { getConsentConfig } from '@/config/consent-config'

type RunOpts = {
	onAccept?: (service: string) => void
	onReject?: (service: string) => void
}

export function useCookieConsent() {
	const run = useCallback(
		(
			config: (
				defaultConfig: VanillaCookieConsent.CookieConsentConfig
			) => VanillaCookieConsent.CookieConsentConfig,
			{ onAccept, onReject }: RunOpts = {}
		) => {
			const onAcceptService = (service: string) => () => {
				onAccept?.(service)
			}

			const onRejectService = (service: string) => () => {
				onReject?.(service)
			}

			const processedConfig = config(getConsentConfig({ onAcceptService, onRejectService }))

			VanillaCookieConsent.run(config(processedConfig))
		},
		[]
	)

	return { ...VanillaCookieConsent, run } as const
}
